import React, { FC, ReactNode } from "react";

import classNames from "classnames";

import styles from "./DetailPriceCell.module.scss";

interface CellProps {
  title: string;
  value: ReactNode;
  isTotal?: boolean;
}

export const DetailPriceCell: FC<CellProps> = ({ title, value, isTotal = false }) => {
  return (
    <div className={styles.detailRow}>
      <span className={classNames(styles.detailTitle, { [styles.totalTitle]: isTotal }, "b3")}>{title}</span>
      <span className={classNames(styles.detailValue, { [styles.totalValue]: isTotal }, "b3")}>{value}</span>
    </div>
  );
};
